import { ref, onMounted, onUnmounted, watch, type Ref } from 'vue'

export function useCountdown(targetDate: Date | Ref<Date | null>) {
  const days = ref(0)
  const hours = ref(0)
  const minutes = ref(0)
  const seconds = ref(0)
  const formattedCountdown = ref('')

  let interval: NodeJS.Timeout | null = null

  const runCountdown = (date: Date) => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime()
      const distance = date.getTime() - now

      if (distance < 0) {
        days.value = 0
        hours.value = 0
        minutes.value = 0
        seconds.value = 0
        formattedCountdown.value = '0d 0h 0m 0s'
        if (interval) {
          clearInterval(interval)
          interval = null
        }
        return
      }

      days.value = Math.floor(distance / (1000 * 60 * 60 * 24))
      hours.value = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      minutes.value = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      seconds.value = Math.floor((distance % (1000 * 60)) / 1000)
      formattedCountdown.value = `${days.value}d ${hours.value}h ${minutes.value}m ${seconds.value}s`
    }

    calculateTimeLeft()
    interval = setInterval(calculateTimeLeft, 1000)
  }

  const targetRef = typeof targetDate === 'object' && targetDate && 'value' in targetDate
    ? targetDate as Ref<Date | null>
    : null
  const targetStatic = targetRef ? null : (targetDate as Date)

  if (targetStatic) {
    runCountdown(targetStatic)
  } else if (targetRef) {
    watch(
      targetRef,
      (date) => {
        if (interval) {
          clearInterval(interval)
          interval = null
        }
        if (date) runCountdown(date)
      },
      { immediate: true }
    )
  }

  onUnmounted(() => {
    if (interval) {
      clearInterval(interval)
    }
  })

  return {
    days,
    hours,
    minutes,
    seconds,
    formattedCountdown,
  }
}


// Next OMMI season launch (00:00 CET). Use this for collection countdown.
export { getNextSeasonLaunchCET } from '~/data/seasons'

// Legacy: fallback if season logic is not used
export function getFourMonthsFromNow(): Date {
  const now = new Date()
  const fourMonthsLater = new Date(now)
  fourMonthsLater.setMonth(now.getMonth() + 4)
  return fourMonthsLater
}

